module.exports = __webpack_public_path__ + "img/8_19.6333f4d3.png";